import http from "../http-common";
import md5 from "md5";

const login = async (data) => {
  return await http
    .post("/auth", {
      phone: data.phone,
      ddi: data.ddi,
      recaptcha: data.recaptcha,
      rememberMe: data.rememberMe,
      redirect: data.redirect,
      password: data.password ? md5(data.password) : undefined,
    })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};



const renewToken = async (sessionToken) => {
  return await http
    .get("/auth/renew-token", {
      headers: { session: sessionToken },
    })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const permissions = async () => {
  return await http
    .get("/auth/permissions")
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};


const twoFARegister = async (token, body) => {
  return await http
    .post("/auth/2fa/register", body, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};
const twoFAVerify = async (token, body) => {
  return await http
    .post("/auth/2fa", body, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const webauthnStart = async (query, recaptcha) => {
  return await http
    .get("/auth/webauthn", {
      params: query,
      headers: {
        recaptcha,
      },
    })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const webauthnLogin = async (data) => {
  return await http
    .post("/auth/webauthn", data)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

export default {
  login,
  renewToken,
  permissions,
  twoFARegister: twoFARegister,
  twoFAVerify: twoFAVerify,
  webauthn: {
    start: webauthnStart,
    login: webauthnLogin,
  },
};
